import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDriverAccess } from '@hooks/useVerifyAccess';

export const DriverLayout = () => {
    useDriverAccess();
    return <Outlet />;
};
